// extracted by mini-css-extract-plugin
export default {"content_section":"S1_BillSavings_content_section__80ZZA","best_fit_savings_line":"S1_BillSavings_best_fit_savings_line__9LXb0"};